document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!form.matches('form[action^="/cart/add"]')) return;

  event.preventDefault();

  const formData = new FormData(form);

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' },
    });

    if (!response.ok) {
      console.error('Add to cart failed:', await response.text());
      return;
    }

    const addedItem = await response.json();

    const cartSectionsResponse = await fetch(`?sections=cart-drawer`);
    const cartSectionsJson = await cartSectionsResponse.json();

    window.eventBus.emit('update:cart:drawer', {
      sections: {
        'cart-drawer': cartSectionsJson['cart-drawer'],
      },
    });

    window.eventBus.emit('open:cart:drawer', { scrollToTop: true });

  } catch (error) {
    console.error('Cart drawer add-to-cart error:', error);
  }
});
